import { SidebarItem, SidebarSection, Text, VStack } from '@direct-frontend/components';
import { StatefulTooltip } from '#shared/ui/StatefulTooltip';
import { getProductFormSectionHref } from '../../model/productFormSectionRouting';
import {
    PRODUCT_FORM_SECTION_IDS,
    PRODUCT_FORM_SECTIONS,
    type ProductFormSection,
} from '../../model/productFormSections';
import styles from './ProductFormSidebar.module.css';

export type ProductFormSidebarProps = {
    productId: string;
    variantId?: string;
    search: string;
    section: ProductFormSection;
    isNew: boolean;
    isLoading?: boolean;
};

const ProductFormSidebarItem = ({
    id,
    href,
    activeSection,
    isLoading,
}: {
    id: ProductFormSection;
    href?: string;
    activeSection: ProductFormSection;
    isLoading?: boolean;
}) => {
    const { title, testId } = PRODUCT_FORM_SECTIONS[id];
    const isUnavailable = href === undefined;
    const isDisabled = isLoading || isUnavailable;
    const item = (
        <SidebarItem
            itemId={id}
            title={title}
            isTitleBold={false}
            isActive={id === activeSection}
            isDisabled={isDisabled}
            href={isDisabled ? undefined : href}
            data-testid={testId}
        />
    );

    return isUnavailable ? (
        <StatefulTooltip title="Сохраните товар" trigger="hover" placement="bottom">
            {item}
        </StatefulTooltip>
    ) : (
        item
    );
};

export const ProductFormSidebar = ({
    productId,
    variantId,
    search,
    section,
    isNew,
    isLoading,
}: ProductFormSidebarProps) => (
    <VStack width="260px" flex="0 0 auto" className={styles.sidebarColumn}>
        <VStack className={styles.sidebar} data-testid="ProductForm.Sections">
            <Text size="s" bold className={styles.sidebarTitle}>
                {isNew ? 'Создание товара' : 'Редактирование товара'}
            </Text>
            <SidebarSection>
                {PRODUCT_FORM_SECTION_IDS.map((id) => {
                    const href = getProductFormSectionHref({ productId, variantId, search, section: id });

                    return (
                        <ProductFormSidebarItem
                            key={id}
                            id={id}
                            href={href}
                            activeSection={section}
                            isLoading={isLoading}
                        />
                    );
                })}
            </SidebarSection>
        </VStack>
    </VStack>
);
